export interface AppConfig {
  apiUrl: string;
}

let config: AppConfig | null = null;

/**
 * Load configuration from public/config.json
 * This file is not bundled and can be modified per environment
 */
export async function loadConfig(): Promise<AppConfig> {
  if (config) {
    return config;
  }

  try {
    const response = await fetch('/config.json');
    if (!response.ok) {
      throw new Error(`Failed to load config: ${response.statusText}`);
    }
    config = await response.json();
    console.log('Configuration loaded:', config);
    return config as AppConfig;
  } catch (error) {
    console.error('Failed to load configuration, using defaults:', error);
    // Fallback to default configuration
    config = {
      apiUrl: 'http://localhost:5000/api'
    };
    return config;
  }
}

/**
 * Get the current configuration
 * Must be called after loadConfig()
 */
export function getConfig(): AppConfig {
  if (!config) {
    throw new Error('Configuration not loaded. Call loadConfig() first.');
  }
  return config;
}

/**
 * Get API URL from configuration
 */
export function getApiUrl(): string {
  return getConfig().apiUrl;
}
